import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello Everyone, this is <span className="purple">Arnav Agarwal </span>
            from <span className="purple"> Lucknow, India.</span>
            <br />
            I have completed B-Tech in <span className="purple">Computer Science and Engineering</span> from Dr. A.P.J Abdul Kalam Technical University (AKTU)
            <br />
            <br />
            Apart from coding, some other activities that I enjoy!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Reading Novels
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing 
            </li>
            <li className="about-activity">
              <ImPointRight /> Football
            </li>
    
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Great works are performed not by strength but by perseverance!!"{" "}
          </p>
          <footer className="blockquote-footer">Anonymous</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
